import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
import { TooltipArrow } from "./arrow.js";
import { TooltipLabel } from "./label.js";
import { TooltipShortcut } from "./shortcut.js";
import { TooltipPopup } from "./popup.js";
import { TooltipProvider } from "./provider.js";
import { TooltipRoot } from "./root.js";
import { TooltipTrigger } from "./trigger.js";
//#region src/ui/tooltip/index.parts.ts
var index_parts_exports = /* @__PURE__ */ __exportAll({
	Arrow: () => TooltipArrow,
	Label: () => TooltipLabel,
	Popup: () => TooltipPopup,
	Provider: () => TooltipProvider,
	Root: () => TooltipRoot,
	Shortcut: () => TooltipShortcut,
	Trigger: () => TooltipTrigger
});
//#endregion
export { TooltipArrow as Arrow, TooltipLabel as Label, TooltipPopup as Popup, TooltipProvider as Provider, TooltipRoot as Root, TooltipShortcut as Shortcut, TooltipTrigger as Trigger, index_parts_exports };

//# sourceMappingURL=index.parts.js.map